import React from 'react';
import PropTypes from 'prop-types';

import BaseCard from '../BaseCard';
import getFavoriteHook from '@hooks/getFavoriteHook';

const EventCard = props => {
    const {
        id,
        title,
        image,
        dateRange,
        displayLocation,
        isFavorite: initialIsFavorite,
        onClick = () => {},
        url,
        isLoggedIn,
    } = props;

    const useFavorite = getFavoriteHook({ type: 'event', initialIsFavorite });
    const { isFavorite, isLoadingFavorite, saveFavorite, removeFavorite } = useFavorite();

    const onFavorite = () => {
        if (isFavorite) {
            removeFavorite(id);
        } else {
            saveFavorite(id);
        }
    };

    const imageBlock = !image ? null : (
        <>
            <a href={url} onClick={() => onClick(url)} onKeyDown={() => onClick(url)} className="card-link">
                {image && <img className="card-img-top w-100" src={image} alt={title} />}
            </a>
        </>
    );

    const titleSpacingClasses = !image ? 'mt-5 mt-sm-6 mt-md-5 mt-lg-6 mb-0 mr-lg-3' : 'mt-4';

    return (
        <BaseCard
            cardClasses="event-card"
            id={id}
            type="event"
            title={title}
            url={url}
            onClick={onClick}
            isFavorite={isFavorite}
            onFavorite={onFavorite}
            isLoadingFavorite={isLoadingFavorite}
            imageBlock={imageBlock}
            isLoggedIn={isLoggedIn}
            contentBlock={
                <>
                    <a href={url} onClick={() => onClick(url)} onKeyDown={() => onClick(url)} className="card-link">
                        <h3 className={`card-title d6-truncate3 display6 truncate-lines bold ${titleSpacingClasses}`}>
                            {title}
                        </h3>
                        {dateRange && <p className="display8 secondary mt-3 mt-md-5 mt-lg-3 mb-0 py-0">{dateRange}</p>}
                        {displayLocation && <p className="display8 secondary mt-4 mb-0 py-0">{displayLocation}</p>}
                    </a>
                </>
            }
        />
    );
};

EventCard.propTypes = {
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    title: PropTypes.string.isRequired,
    image: PropTypes.string,
    dateRange: PropTypes.string,
    displayLocation: PropTypes.string,
    url: PropTypes.string,
    isFavorite: PropTypes.bool.isRequired,
    onClick: PropTypes.func,
    isLoggedIn: PropTypes.bool,
};

export default EventCard;
